import styled from "styled-components";

export const DashboardStyle = styled.div`
  width: 90%;
  position: relative;
  margin: auto;
  margin-top: 20px;
`;
